import { Link } from 'react-router-dom';
import React from 'react';
import '../../assests/css/footer.css'
import logo from '../../assests/images/logo.png'
import poweredImage from '../../assests/images/metrologo.png';


const Footer = () => {
    return (
        <div className='footer'>
            <div className='container '>
                <div className='row mt-5'>
                    <div className='col-md-5 text-cen-res-rest pe-5 pe-res-footer'>
                        <Link to="/"><img src={logo} className='logo-img-footer px-2' alt='logo' /></Link>
                        <p className='f-18 mt-2 footer-common-clr'>
                            Metro 24 x 7 is a reliable airport transfer services dedicated
                            to ensuring the safety and satisfaction of our clients by
                            offering prompt assistance and ease of booking. Whether you
                            need immediate service to drop you at the airport or need
                            a ride to get back to your place from the airport, you
                            will have the leading stansted airport transfers’ full
                            support.
                        </p>
                        <p className='f-22 mt-3 mb-2'>Timing</p>
                        <p className='f-18 mt-3 mb-2 footer-common-clr'>Mon To Sun : 24X7</p>
                    </div>
                    <div className='col-md-2 '>
                        <p className='f-20 mb-2-9'>Quick Links</p>
                        <Link className='link_footer_co' to="/refundpolicy"><p className='mb-3 no_style clr-light-footer'>Refund Policy</p> </Link>
                        <Link className='link_footer_co' to="/cookiepolicy"> <p className='mb-3 no_style clr-light-footer'>Cookie Policy</p> </Link>
                        <Link className='link_footer_co' to="/privacypolicy"> <p className='mb-3 no_style clr-light-footer'>Privacy Policy</p> </Link>
                        <Link className='link_footer_co' to="/faqs"><p className='mb-3  no_style clr-light-footer'>FAQ'S</p></Link>
                        {/* <Link className='link_footer_co' to="/myprofile"><p className='mb-3'>Booking history</p></Link>  */}
                    </div>
                    <div className='col-md-5'>
                        <div className='row'>
                            <div className='col-lg-12 text-cen-res'>

                                <p className='f-20 mb-2-9'>Nearby Cities/Town</p>
                            </div>
                            <div className='col-lg-4 text-cen-res'>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Dunmow" }}
                                ><p className='mb-3 f-last'>Dunmow</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Saffron Walden" }}
                                ><p className='mb-3 f-last'>Saffron Walden</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Thaxted" }}
                                ><p className='mb-3 f-last'>Thaxted</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Much Hadham" }}
                                ><p className='mb-3 f-last'>Much Hadham</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "North Weald" }}
                                ><p className='mb-3 f-last'>North Weald</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Hertford" }}
                                ><p className='mb-3 f-last'>Hertford</p></Link>
                            </div>
                            <div className='col-lg-4 text-cen-res'>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Buntingford" }}
                                ><p className='mb-3 f-last'>Buntingford</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Cambridge" }}
                                ><p className='mb-3 f-last'>Cambridge</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Braintree" }}
                                ><p className='mb-3 f-last'>Braintree</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Bishops stortford" }}
                                ><p className='mb-3 f-last'>Bishops stortford</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Ongar" }}
                                ><p className='mb-3 f-last'>Ongar</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Ware" }}
                                ><p className='mb-3 f-last'>Ware</p></Link>
                            </div>
                            <div className='col-lg-4 text-cen-res'>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Harlow" }}
                                ><p className='mb-3 f-last'>Harlow</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Epping" }}
                                ><p className='mb-3 f-last'>Epping</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Hoddesdonng" }}
                                ><p className='mb-3 f-last'>Hoddesdon</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Nazeing" }}
                                ><p className='mb-3 f-last'>Nazeing</p></Link>
                                <Link className='link_footer_co'
                                    to="/flitwick" state={{ pageName: "Chelmsford" }}
                                ><p className='mb-3 f-last'>Chelmsford</p></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='footer-border-btm mt-4'>

            </div>
            <div className='footer-copyrights'>
                <div className='container '>
                    <div className='row mt-4'>
                        <div className='col-md-6 text-cen-res-rest mb-0 text-start'>
                            <p className='f-18 footer-common-clr'>Copyright2021. All Right Reserved</p>
                        </div>
                        <div className='col-md-6 text-cen-res-rest mb-0 text-end'>
                            <span className='me-5 footer-common-clr'>Powered By : </span>
                            <img src={poweredImage} alt="powered logo" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;